import React, { useEffect } from 'react'
import { getDashBoardStats } from '../../utils/templatesApi'
import './dasboard.css'
import { toast } from 'react-toastify'
import { Box, CircularProgress } from '@mui/material'

const DashBoardStats = ({ setRenderComponent, renderComponent }) => {
  const [loading, setLoading] = React.useState(false)
  const [stats, setStats] = React.useState({})
  const getStats = async () => {
    try {
      setLoading(true)
      const resposne = await getDashBoardStats()
      setStats(resposne)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log('error: ', error)
      toast.error('Something went wrong while fetching stats')
    }
  }

  useEffect(() => {
    getStats()
  }, [])

  const handleRadioChange = event => {
    setRenderComponent(event.target.value)
  }

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '8vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <div className='container'>
          <div className='tabs'>
            <input
              type='radio'
              id='users-radio'
              name='dashboard-radio'
              value='users'
              checked={renderComponent === 'users'}
              onChange={handleRadioChange}
            />
            <label
              htmlFor='users-radio'
              style={{ cursor: 'pointer' }}
              className='tab'
            >
              <span>Users</span>
              <span className='notification'>{stats.totalUsers}</span>
            </label>
            <input
              type='radio'
              id='templates-radio'
              name='dashboard-radio'
              value='templates'
              checked={renderComponent === 'templates'}
              onChange={handleRadioChange}
            />
            <label
              htmlFor='templates-radio'
              style={{ cursor: 'pointer' }}
              className='tab'
            >
              <span>Templates</span>
              <span className='notification'>{stats.totalTemplates}</span>
            </label>
            <span className='glider'></span>
          </div>
        </div>
      )}
    </>
  )
}

export default DashBoardStats
